<template>
  <div class="page_content" v-if="rdata">
    <el-pagination style='float:right;'
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="rdata.currentPage"
                   :page-sizes="arraySizes"
                   :page-size="rdata.pageSize"
                   :layout="layout"
                   :total="rdata.total">
    </el-pagination>
  </div>
</template>

<script>
  export default{
    data(){
      return {
        arraySizes: [20, 30, 30, 40],
        layout: "total, sizes, prev, pager, next"
      }
    },
    deactivated(){
      this.$destroy(true)
    },
    props: ['rdata', 'action', 'arraySize','layoutIn'],
    mounted () {
      var that = this


      if (that.arraySize) that.arraySizes = that.arraySize.replace("[","").replace("]","").split(",")
      if (that.layoutIn) that.layout = that.layoutIn
    },
    methods:{
      handleSizeChange (v) {
        this.action.handleSizeChange(v)
      },
      handleCurrentChange (v) {
      	this.action.handleCurrentChange(v)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// paging.vue?aa64ef46